import React from 'react';

import {assert} from 'Asserts';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getStudyTypeText, isClinicalOrPreclinicalStudy} from 'studies/TypedStudyUtils';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function PublishingWarningBanner({studyType}: {studyType: StudyType}): JSX.Element {
  assert(isClinicalOrPreclinicalStudy(studyType), 'Study type must be clinical or preclinical');
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      text="Template publishing is not enabled for this tenant."
      supportingInfo={
        <>
          Using {getStudyTypeText(studyType)} Studies without template publishing is risky. A study could be
          approved with a different assay version from the version used to test samples, which could prevent
          samples from being tested.
        </>
      }
    />
  );
}
